import React from 'react';
import { useTranslation } from 'react-i18next';
import { BD } from '../bookDemoTheme';

interface NavButtonsProps {
  onBack?: () => void;
  onContinue: () => void;
  continueLabel?: string;
  continueDisabled?: boolean;
  hideBack?: boolean;
}

const NavButtons: React.FC<NavButtonsProps> = ({
  onBack,
  onContinue,
  continueLabel,
  continueDisabled = false,
  hideBack = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="sm:px-4 w-full mt-auto pt-8 sm:pt-10 pb-8 sm:pb-12">
      <div className="max-w-[697px] mx-auto w-full flex flex-row items-center justify-center gap-3 sm:gap-6">
        {!hideBack && (
          <button
            type="button"
            onClick={onBack}
            className={`border w-full h-11 rounded-xl text-[14px] leading-5 font-semibold transition-colors ${BD.backButton}`}
          >
            {t('bookDemo.nav.back')}
          </button>
        )}
        <button
          type="button"
          onClick={onContinue}
          disabled={continueDisabled}
          className={`w-full h-11 rounded-xl text-[14px] leading-5 font-semibold transition disabled:cursor-not-allowed ${BD.primaryButton}`}
        >
          {continueLabel ?? t('bookDemo.nav.continue')}
        </button>
      </div>
    </div>
  );
};

export default NavButtons;
